import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect,Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { format} from 'date-fns';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";

import { URL_IMG} from '../../configs/urlConfigs';
import { SCROLL_PAGING_CREW_AVAILABILITY_COUNT,CREW_MAX_RATING,LOGIN_AFFILIATE_GROUP, ENUM_MM5, ENUM_SHIFT_LENGTH_HHMM} from '../../configs/staticConfigs';
import { LBL_APP_NAME,LBL_TIME,LBL_HH_MM,LBL_SELECT,LBL_SHIFT_LENGTH,LBL_WORKING_HRS_DESC,LBL_SEARCH,LBL_END_DATE,LBL_START_DATE,LBL_CREW_AVAILABILITY, LBL_SKILLS, LBL_DEPARTMENTS,LBL_PAY_LEVELS} from '../../configs/labelConfigs';
import { MSG_NO_DEPT_SKILL_SELECTED,MSG_CREW_AVAILABILITY_NOT_FOUND} from '../../configs/msgConfigs';

import CustomMultiSelect from '../commons/helpers/customMultiSelect';

import * as types from '../../actions';
import { serverTimeAction} from '../../actions/commonActions';
import { crewAffSkillListAction} from '../../actions/crewActions';
import { aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import { payLevelsListAction} from '../../actions/settings/affiliates/payLevelsActions';
import { crewAvailabilityReportAction} from '../../actions/eventActions';

import { userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { converDateToLocal,convertDecimalToHHMM} from '../../utils/commonUtilities';
import { titleCase} from '../../utils/changeCase';
import { checkNumColon} from '../../utils/validation';

const MSG_DEFAULT_CREW_LIST = MSG_CREW_AVAILABILITY_NOT_FOUND;
class CrewAvailabilityReportComponent extends Component {

    constructor(props){
        super(props)
        this.state = { 
            departmentsList: [],
            deptMultiSelList: [],
            selectedDepartments:[],
            skillMultiList:[],
            errorMessage:'',
            crewList:[],
            hasMore:false,
            startDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            defaultStartDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            endDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            defaultEndDate:format(new Date(), 'yyyy-MM-dd')+" 00:00:00",
            startTime:'00:00',
            endTime:'08:00',
            skillIds:[],
            departmentIds:[],
            shiftLength:'08:00',
            currentPage:1,
            perPageCount:SCROLL_PAGING_CREW_AVAILABILITY_COUNT,
            payLevelMultiSelList: [],
            payLevelListAll: [],
            selectedPayLevels: [], 
        }
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:0}; 
              allDept.push(tmpObj);
           }) 
           
            this.setState({deptMultiSelList:allDept},()=>{                
                this.sendFilterData();
            }); 
        }
     }

    onskillDataChange = (selectedStatus) =>{
        let skillIds = [];
        selectedStatus.forEach((item) => {
            skillIds.push(parseInt(item.value,10));
        });
        this.setState({skillIds:skillIds});
    }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    onChangePayLevelMultiSel = (selectedPLs) =>{
        let actPLs = []; 
        selectedPLs.forEach((item) => {
           actPLs.push(item.value);
        }); 
        this.setState({selectedPayLevels:actPLs}); 
    } 

    onStartDateChange = (date) =>{
        let { startDate, endDate} = this.state;
        if(date==='' || date===null){
            startDate = format(this.state.defaultStartDate, 'yyyy-MM-dd')+" 00:00:00";
        }else{
            startDate = format(new Date(date), 'yyyy-MM-dd')+" 00:00:00";
        }
        endDate = startDate
        this.setState({startDate, endDate},()=>{
            this.calculateEndDateAndTime();
        });
         
           
    }
    onHandleChangeStartTime = (time) =>{
        let {startTime} = this.state;    
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm');           
            this.setState({startTime});
        }
    }
    onBlurStartTime = (time) =>{
        let {startTime} = this.state;
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm');
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                startTime = format(d, 'HH:mm');
            }catch(err) {
                var hours = 0;
                if(s && s.indexOf(':')==-1 && !isNaN(s)){
                    hours = parseInt(s, 10);
                }
                
                var minutes = 0;
                var d = new Date();
                d.setHours(hours);
                d.setMinutes(minutes);
                startTime = format(d, 'HH:mm');
                this.setState({startTime});
            }
        } 
        this.setState({startTime}, () => {
            this.calculateEndDateAndTime();

        });
                
    }
    calculateEndDateAndTime=()=>{
        let {startDate, startTime, shiftLength, endDate, endTime} = this.state;
        let startDate_tmp = startDate;
        if(startDate === ''){
            startDate_tmp = new Date();
        }else{
            if(typeof(startDate_tmp) == "string" && startDate_tmp.split('T').length > 1){
                // startDate_tmp = new Date(startDate_tmp.split('T')[0]+" 00:00:00");
                startDate_tmp = new Date(startDate_tmp.split('T')[0]+"T00:00:00");
            }else{
                startDate_tmp = new Date(startDate_tmp);
            } 
        }
        
        var s = startTime === '' ? format(startDate_tmp, 'HH:mm') : startTime,
            parts = s.match(/(\d+)\:(\d+)/),
            hours = parseInt(parts[1], 10),
            minutes = parseInt(parts[2], 10);
        if(shiftLength === ''){
            shiftLength = "00:00";
        }

        let arrTime = shiftLength.split(':'); 
        let hrs = arrTime[0] && arrTime[0]!=='' ? arrTime[0] : 0; 
        let mins = arrTime[1] && arrTime[1]!=='' ? arrTime[1] : 0; 
        startDate_tmp.setHours(hours);
        startDate_tmp.setMinutes(minutes+Number(mins));
        startDate_tmp.setHours( startDate_tmp.getHours() + Number(hrs));
        endDate = format(startDate_tmp, 'yyyy-MM-dd')+" 00:00:00";
        endTime = format(startDate_tmp, 'HH:mm');

        this.setState({endDate,endTime, startTime, shiftLength});
    }

    onHandleChangeShiftLength = (time) =>{
        
        let {shiftLength} = this.state;
        if(time._d !== undefined){
            shiftLength = format(new Date(time._d), 'HH:mm');
            this.setState({shiftLength});
        }
        else {
            let timeStr = time.toString().trim();
            if(!checkNumColon(timeStr)) {
                timeStr = '00:00'; 
            }

            if(timeStr.indexOf(':') >=0 || timeStr!=='' || parseInt(timeStr,10) >= 0) {
                shiftLength = timeStr;
            }
            else if(timeStr==='') {
                shiftLength = '';
            }
            this.setState({shiftLength});
        }
    }

    onBlurShiftLength = (time) =>{
        let {shiftLength} = this.state;
        let slError = ''; 
        if(time._d !== undefined){
            shiftLength = format(new Date(time._d), 'HH:mm'); 
        }else{
            let timeStr = time.toString().trim();
            
            if(!checkNumColon(timeStr)) {
                timeStr = ''; 

            }

            if(timeStr.indexOf(':') >=0) {
                try{
                    var d = new Date(),
                        s = timeStr,
                        parts = s.match(/(\d+)\:(\d+)/),
                        hours = parseInt(parts[1], 10),
                        minutes = parseInt(parts[2], 10);

                    d.setHours(hours);
                    d.setMinutes(minutes);
                    shiftLength = format(d, 'HH:mm');
                }catch(err) {

                }
            }
            else if(timeStr==='') {
                shiftLength = '';
            }else{
                shiftLength = '';
            }
        } 
        this.setState({shiftLength});
        this.calculateEndDateAndTime();        
    }

    sendFilterData = () =>{

        let {startDate,endDate,startTime,endTime,skillIds,selectedDepartments,currentPage,perPageCount,selectedPayLevels} = this.state;
        if(selectedDepartments.length===0 || skillIds.length===0){
            this.setState({errorMessage:MSG_NO_DEPT_SKILL_SELECTED,crewList:[]});
        }else{
            let startDateTime = startDate+" "+startTime+":00";
            let endDateTime = endDate+" "+endTime+":00";
            this.props.crewAvailabilityReportAction({departmentIds:selectedDepartments,
                                    skillIds:skillIds,startDateTime:startDateTime,
                                    endDateTime:endDateTime,page:1,pageSize:perPageCount,payLevelIds:selectedPayLevels});
        }
        
    }

    findMoreCrew =(fromAddCrew) =>{ // pagination
        let {startDate,endDate,startTime,endTime,skillIds,selectedDepartments,currentPage,perPageCount,selectedPayLevels} = this.state;
        let nextPage = currentPage+1;
        if(fromAddCrew){ //to fetch again to fill the removed crew postion
            nextPage = currentPage;
        }
        let currentPageSize = perPageCount*nextPage;

        let startDateTime = startDate+" "+startTime;
        let endDateTime = endDate+" "+endTime;
        this.props.crewAvailabilityReportAction({departmentIds:selectedDepartments,
                                skillIds:skillIds,startDateTime:startDateTime,
                                endDateTime:endDateTime,page:1,pageSize:currentPageSize,payLevelIds:selectedPayLevels});
        
        this.setState({currentPage: nextPage}); 
    }

    componentDidMount() {
    	const { location } = this.props;
    	let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        } 
    	if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.props.serverTimeAction();
        this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:''});
        this.props.aflt_departmentsListAction({page:0,column:'name',pageSize:'',associated:'1'}); 
        this.props.payLevelsListAction(); 
        document.title = LBL_APP_NAME+" - "+LBL_CREW_AVAILABILITY; 
    }

    loadMultiSelPayLevels() {
        let allPL = []; 
        if(this.state.payLevelListAll.length > 0) {
           this.state.payLevelListAll.forEach((item,index) => { 
              allPL.push({value:item.id, label:titleCase(item.level_name), inputVal:0});
           }) 
           this.setState({payLevelMultiSelList:allPL}); 
        }
     } 

    componentDidUpdate (prevProps) {
        const {subactivity,skillList,crewProfileActivity,availabilityCrewCount,availabilityCrewList,payLevelListAll,payLevelActivity} = this.props;
        
        if(payLevelActivity && payLevelActivity !== prevProps.payLevelActivity){
            let arrPL = this.props.payLevelActivity.split('~~');
            if(arrPL[0]===types.PAY_LEVELS_LIST_SUCCESS){
                this.setState({payLevelListAll:payLevelListAll}, () => {
                    this.loadMultiSelPayLevels(); 
                })
            }
        } 

        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let strDate = format(defaultEndDate, 'yyyy-MM-dd')
                this.setState({defaultStartDate:defaultEndDate,defaultEndDate:defaultEndDate,
                            startDate:strDate+" 00:00:00",endDate:strDate+" 00:00:00"})
            }
        } 
        if(subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 

            if(actString===types.CREW_AFFILIATE_SKILL_LIST_SUCCESS){
                //console.log('skillList'); 
                //console.log(skillList); 
                let skillMultiList = [];
                if(Array.isArray(skillList) && skillList.length>0){
                    skillList.forEach(item => {
                        skillMultiList.push({value:item.id,label:item.skill_name});
                    });
                }
                this.setState({skillMultiList});
            }else if(actString===types.CREW_AVAILABILITY_REPORT_SUCCESS){ 
                    this.setState({crewList:availabilityCrewList,totalCrewCount:availabilityCrewCount});
                    this.setState({hasMore: (Number(availabilityCrewCount)>Number(availabilityCrewList.length)), errorMessage:Number(availabilityCrewCount)===0?MSG_CREW_AVAILABILITY_NOT_FOUND:MSG_DEFAULT_CREW_LIST});                            
            }
        }
        if(crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity){
            let arrResp = crewProfileActivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if(this.props.afltDepartmentsForCrew.length===0) {
                          this.setState({departmentsList: []}, () => {
                             this.loadMultiSelDeptValues(); 
                          } ); 
                    }
                    else {     
                          this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }
                }
            }
        }
    }

    render(){ 

        const {startDate,endDate,deptMultiSelList,skillMultiList,crewList,errorMessage,hasMore,payLevelMultiSelList} = this.state;
        let selectedStartDate = new Date(startDate)
        let selectedEndDate = new Date(endDate)
        let timeZone = getUserTimeZone(this.props.location);
    	return(
    		<React.Fragment>
    			<div className="col-md-12">
                    <div className="box col-md-12"> 
                        <div className="row">
                            <div className="form-group displayItemFlex marginBottomO">                           
                                <div className="col-md-3">
                                    <label>{LBL_SKILLS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={skillMultiList}  onChange={selected =>this.onskillDataChange(selected)} isTextBox={false} needSelectAll={true} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label>{LBL_DEPARTMENTS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={deptMultiSelList}  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' needSelectAll={true} />
                                        </div>
                                    </div> 
                                </div>
                                <div className="col-md-3">
                                    <label>{LBL_PAY_LEVELS}</label>
                                    <div className="form-group multisel_textbox">
                                        <div className="form-group select-input skills" >
                                            <CustomMultiSelect id={'dept'} data={payLevelMultiSelList}  onChange={selected =>this.onChangePayLevelMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' needSelectAll={true} />
                                        </div>
                                    </div> 
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div className="box col-md-12"> 
                        <div className="row">
                            <div className="form-group displayItemFlex marginBottomO"> 
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{LBL_START_DATE}</label>
                                                <div className={'calendar-input'}>
                                                    <DatePicker 
                                                        selected={selectedStartDate}
                                                        onChange={selected =>this.onStartDateChange(selected)}
                                                        name="startDate"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select"
                                                        fixedHeight
                                                        minDate={new Date()}           
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label>{LBL_TIME}</label>
                                                <div className={'time-input'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime'}}  value={this.state.startTime} onChange={selected=>this.onHandleChangeStartTime(selected)} onBlur={selected=>this.onBlurStartTime(selected)}
                                                    timeConstraints={ ENUM_MM5 } 
                                                    /> 
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="form-group"> 
                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="form-group"> 
                                                <label>{LBL_SHIFT_LENGTH}</label>
                                                <div className={'time-input'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'shiftLength'}}  value={this.state.shiftLength} onChange={selected=>this.onHandleChangeShiftLength(selected)}  onBlur={selected=>this.onBlurShiftLength(selected)} 
                                                    timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                                                </div>
                                            </div>
                                                
                                            </div>
                                            <div className="col-md-6">
                                            <label>{LBL_END_DATE}</label>
                                                <div className={'calendar-input text-optional'}>
                                                    <DatePicker 
                                                        selected={selectedEndDate}
                                                        onChange={selected =>this.onStartDateChange(selected)}
                                                        name="endDate"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select"
                                                        fixedHeight
                                                        disabled={true}           
                                                    />
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-md-3">
                                    <div className="form-group"> 
                                        <div className="row">
                                            <div className="col-md-6">
                                            <div className="form-group"> 
                                            <label>{LBL_TIME}</label>
                                                <div className={'time-input text-optional'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', disabled:true}}  value={this.state.endTime} onChange={selected=>this.onHandleChangeStartTime(selected)}  
                                                    timeConstraints={ ENUM_MM5 } 
                                                    /> 
                                                    
                                                </div>
                                            </div>
                                                
                                            </div>
                                            <div className="col-md-6 floatRight">
                                            <button type="button" className="btn btn-primary marginTop-25 floatRight" onClick={this.sendFilterData}>{LBL_SEARCH}</button>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                
                                

                                {/* <div className="col-md-2" style={{maxWidth: '12.5%'}}>
                                    <div className="form-group"> 
                                        <label>{LBL_SHIFT_LENGTH}</label>
                                        <div className={'time-input'}>
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: LBL_SELECT, name:'shiftLength'}}  value={this.state.shiftLength} onChange={selected=>this.onHandleChangeShiftLength(selected)}  onBlur={selected=>this.onBlurShiftLength(selected)} 
                                            timeConstraints={ ENUM_SHIFT_LENGTH_HHMM }/> 
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="col-md-3">
                                    <div className="form-group"> 
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>{LBL_END_DATE}</label>
                                                <div className={'calendar-input text-optional'}>
                                                    <DatePicker 
                                                        selected={selectedEndDate}
                                                        onChange={selected =>this.onStartDateChange(selected)}
                                                        name="endDate"
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        dateFormat="dd/MM/yyyy"
                                                        placeholderText="Select"
                                                        fixedHeight
                                                        disabled={true}           
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label>{LBL_TIME}</label>
                                                <div className={'time-input text-optional'}>
                                                    <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', disabled:true}}  value={this.state.endTime} onChange={selected=>this.onHandleChangeStartTime(selected)}  
                                                    timeConstraints={ ENUM_MM5 } 
                                                    /> 
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                
                                {/* <div className="col-md-2" >
                                    <button type="button" className="btn btn-primary marginTop-25 float-left" onClick={this.sendFilterData}>{LBL_SEARCH}</button>
                                </div> */}

                                </div>
                            </div>
                    </div>
                    
                    
                </div>

                <div className="col-md-12 min-height-50VH margin-top-1rem">
                    <div className={crewList.length <=0?'box col-md-12 pl-0 pr-0 bg-white':'schedule-crew-list box col-md-12 pl-0 pr-0 bg-white'}>                            
                        {
                            errorMessage && crewList.length <=0 &&
                            <div className="crew-list__noitem">{errorMessage}</div>
                        }


                        { crewList.map((crew, index)  => {
                            
                            let skillStr = '', skillName = ''; 
                            let arrSkillNames = [], crewSkillDropdown = [];
                            let isChief = 0; 
                            {/*if(crew.skills_dropdown && Array.isArray(crew.skills_dropdown) && crew.skills_dropdown.length > 0) { 
                                crew.skills_dropdown.forEach(skill =>{ 
                                    if(String(skill.chief_eligibility)==='true'){
                                        isChief = 1;  
                                        skillName = lblChief+' - '+skill.skill_name; 
                                    }
                                    else {
                                        isChief = 0;  
                                        skillName = skill.skill_name;
                                    }
                                    crewSkillDropdown.push({skill_id:skill.skill_id,skill_name:skillName,isChief:Number(isChief)});
                                    if(!arrSkillNames.includes(skill.skill_name)) {
                                        arrSkillNames.push(skill.skill_name);  
                                        skillStr += skill.skill_name+', ';
                                    }
                                });   
                            */}
                            
                            let crewProfileId = crew.profile_id;
                            let imageClass = crew.chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                            let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew.user.first_name} title={crew.user.first_name} />;

                            if ((crew.profile_picture) && crew.profile_picture.trim().length > 0){
                                profileImgTag = <img className={imageClass} src={crew.profile_picture} alt={crew.user.first_name} title={crew.user.first_name} />;
                            }else if(((!crew.profile_picture) || crew.profile_picture.trim().length===0) && crew.avatar_name && crew.avatar_name.trim().length > 0){
                              
                                profileImgTag = <div title={crew.user.first_name+' '+crew.user.last_name} className={crew.chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crew.profile_color}}>{crew.avatar_name}</div>; 
                            }

                            const chiefIcon = crew.chief_eligibility? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                            const vehicleInfo = crew.has_vehicle?<span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>:'';
                            let crewRating = crew.crew_total_rating;

                            let department = crew.department.length>0?crew.department.map(e => e.name).join(",\r"):''

                            return(
                                <div className="s-crew-border" key={index}>
                                    <div className="row">
                                        <div className="rightAlign padding-right-20" >
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 450, hide: 250 }}
                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                    opacity: 0.4,
                                                }}>
                                                {LBL_WORKING_HRS_DESC}
                                            </Tooltip>}
                                            >
                                                <span className="badge badge-pill badge-primary shift-count">{convertDecimalToHHMM(crew.thirty_days)}</span>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div className="crew minHeight125">
                                        <div className="crew__aside">
                                            <div className="crew__thumb">
                                                {profileImgTag}
                                            </div>
                                            <span className="crew__badge font__size__12">{crew.omnu_points}</span>
                                            <div className="crew__rating rating-display-only">
                                                {CREW_MAX_RATING.map(ratingNum => {
                                                    if(Number(ratingNum) <= crewRating) {
                                                        return(
                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum}  data-id={ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                    )
                                                    }else{
                                                        if(parseFloat(ratingNum)-0.5===parseFloat(crewRating)){
                                                            return(
                                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                            )
                                                        }else{
                                                            return(
                                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                            )
                                                        } 
                                                    }                                  
                                                })
                                                }
                                            </div>
                                        </div>
                                        <div className="crew__content">
                                            <div className="crew__desc">
                                                <div className="row paddingLeft15 mb-0 paddingBottomp0">
                                                    <div className="col8 text14Bold paddingBottomp0 ">{chiefIcon} {vehicleInfo} <b>{crew.user.first_name+' '+crew.user.last_name}</b> <p className="paddingTop0 paddingBottomp0"><small>{crew.pay_level_name}</small></p>
                                                    </div>
                                                </div>
                                                <div className="row paddingLeft15 paddingTop5 text11 text-muted">{department}</div>
                                                <div className="row paddingLeft15 mb-0 paddingBottomp0 display-block">
                                                {crew.crewskills_set.map((skill, index)  => {
                                                        return(
                                                            <React.Fragment key={index}>
                                                            <p className="mb-0"><small><i className={'fas '+ skill.skill_icon}></i> {skill.skill_name}</small></p>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                    }
                                                </div>
                                                <div className="row">
                                                    {crew.prevoius_shifts.length > 0 &&
                                                        crew.prevoius_shifts.map((p_shift,index) =>{
                                                            return(
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    delay={{ show: 450, hide: 250 }}
                                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                        opacity: 0.4,
                                                                    }}>
                                                                    {p_shift.shift_title+' @ '+p_shift.event_title + ' ('+converDateToLocal(p_shift.start_time,timeZone.utc_offset,'ddmmyyyyhhmm')+')'}
                                                                </Tooltip>}
                                                                >
                                                                <div className={"schedule_shift_box previous-shift"}>
                                                                        <span className="badge"> {convertDecimalToHHMM(p_shift.shift_length)}</span>
                                                                </div>
                                                                </OverlayTrigger>
                                                               
                                                            )
                                                        })  
                                                    }
                                                    {crew.upcoming_shift.shift_title &&
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    delay={{ show: 450, hide: 250 }}
                                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                        opacity: 0.4,
                                                                    }}>
                                                                    {crew.upcoming_shift.shift_title+' @ '+crew.upcoming_shift.event_title + ' ('+converDateToLocal(crew.upcoming_shift.start_time,timeZone.utc_offset,'ddmmyyyyhhmm')+')'}
                                                                </Tooltip>}
                                                                >
                                                                <div className={"schedule_shift_box"}>
                                                                        <span className="badge">{convertDecimalToHHMM(crew.upcoming_shift.shift_length)}</span>
                                                                </div>
                                                                </OverlayTrigger> 
                                                    }
                                                </div>
                                                                                            
                                                
                                            </div> 
                                            
                                        </div>
                                    </div>
                                </div>  
                            )


                        })

                        }                                                                                
                    </div>
                    {   hasMore &&
                        <div className="box loadmore-block">
                            <Link to="#" onClick={(e) => this.findMoreCrew(false)} >View more</Link>
                        </div>
                    } 

                </div> 


    		</React.Fragment>
    	)
    }
}

const mapStateToProps = (state) => {
    return {
        subactivity:state.event.subactivity, 
        skillList:state.event.skillList,
        errorData:state.event.errorData,
        afltDepartmentsForCrew:state.crews.afltDepartmentsForCrew,
        aflt_departmentsListAction:aflt_departmentsListAction,
        crewProfileActivity:state.crews.crewProfileActivity,   
        availabilityCrewList:state.event.availabilityCrewList,
        availabilityCrewTotalPage:state.event.availabilityCrewTotalPage,
        availabilityCrewNumRows:state.event.availabilityCrewNumRows,
        availabilityCrewCount:state.event.availabilityCrewCount,
        availabilityTotalPage:state.event.availabilityTotalPage,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,   
        payLevelListAll : state.payLevel.items,
        payLevelActivity:state.payLevel.subactivity,
    }
}           

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewAffSkillListAction:crewAffSkillListAction,
        aflt_departmentsListAction:aflt_departmentsListAction,
        crewAvailabilityReportAction:crewAvailabilityReportAction,
        serverTimeAction:serverTimeAction,
        payLevelsListAction:payLevelsListAction,  
    },dispatch);
}               


export default connect(mapStateToProps,mapDispatchToProps)(CrewAvailabilityReportComponent);